"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FONT_SIZES = void 0;
var FONT_SIZES = ['8', '9', '10', '11', '12', '13', '14', '15', '16', '18', '20', '22', '24', '28', '30', '36', '48', '60', '72'];
exports.FONT_SIZES = FONT_SIZES;